import axiosInstance from "@/utils/axiosInstance";

export interface PMDashboardStats {
  activeProjects: number;
  activeDistricts: number;
  reassignmentNeeded: number;
  unassignedSubmissions: number;
  autoAssignedActive: number;
  manualAssignedActive: number;
  assignmentUnresolved: number;
  ddoWorkloadSpread: number;
}

export interface PMSubmissionQueueItem {
  submission_id: number;
  tenant_id?: number;
  status: string;
  program_code?: string | null;
  academic_year?: number | null;
  assigned_to_user_id?: number | null;
  assigned_to_username?: string | null;
  assignment_source?: string | null;
  routing_reason?: string | null;
  assigned_at?: string | null;
  locked?: boolean;
  lifecycle_phase: string;
  review_state: string;
  latest_governance_event: string;
  latest_governance_actor?: string | null;
  latest_governance_reason?: string | null;
  latest_governance_phase?: string | null;
  latest_return_source?: string | null;
  actionability_state: string;
  blocking_reason: string;
  executable_action_count: number;
  assignment_state: string;
  assignment_age_days?: number | null;
}

export interface PMSubmissionQueueResponse {
  total: number;
  items: PMSubmissionQueueItem[];
}

export interface PMFlagItem {
  code: string;
  label: string;
  severity: string;
  count: number;
  source: string;
}

export interface PMFlagsResponse {
  authority: string;
  total: number;
  items: PMFlagItem[];
}

export interface PMSupervisoryInterventionPayload {
  action_code: string;
  intervention_reason: string;
  remarks?: string;
}

export interface PMSubmissionQueueParams {
  status_filter?: string;
  limit?: number;
}

export async function fetchPMDashboard(): Promise<PMDashboardStats> {
  const res = await axiosInstance.get<PMDashboardStats>("/pm/dashboard");
  return res.data;
}

export async function fetchPMSubmissions(
  params?: PMSubmissionQueueParams
): Promise<PMSubmissionQueueResponse> {
  const res = await axiosInstance.get<PMSubmissionQueueResponse>(
    "/pm/submissions/queue",
    { params }
  );
  return res.data;
}

export async function fetchPMFlags(): Promise<PMFlagsResponse> {
  const res = await axiosInstance.get<PMFlagsResponse>("/pm/flags");
  return res.data;
}

export async function submitPMSupervisoryIntervention(
  submissionId: number,
  payload: PMSupervisoryInterventionPayload
): Promise<unknown> {
  const res = await axiosInstance.post(
    `/pm/submissions/${submissionId}/intervene`,
    payload
  );
  return res.data;
}
